import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { AnimationOptions } from 'ngx-lottie';
import { environment } from 'src/environments/environment';
import { IxfiThemeService } from 'header';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-loader',
    template: `
        <div class="loader-container" [ngClass]="isDarkMode ? 'bg-dark' : 'bg-light'">
            <div class="loader-logo">
                <img
                    [src]="CDN_URL + 'shared/preloader.webp'"
                    width="50px"
                    height="50px"
                    alt=""
                    style="margin-bottom: 5px" />
                <div class="waviy">
                    <span style="--i: 1">P</span>
                    <span style="--i: 2">l</span>
                    <span style="--i: 3">e</span>
                    <span style="--i: 4">a</span>
                    <span style="--i: 5">s</span>
                    <span style="--i: 6">e</span>
                    <span style="--i: 7">&nbsp; w</span>
                    <span style="--i: 8">a</span>
                    <span style="--i: 9">i</span>
                    <span style="--i: 10">t</span>
                </div>
            </div>
        </div>
    `,
    styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit, OnDestroy {
    isDarkMode!: boolean;
    CDN_URL = environment.CDN_URL;
    options: AnimationOptions = {
        path: `${this.CDN_URL}app-loader.json`
    };
    private themeService = inject(IxfiThemeService);

    private themeSub!: Subscription;

    ngOnInit(): void {
        this.themeSub = this.themeService.themeObs.subscribe({
            next: isDarkMode => (this.isDarkMode = isDarkMode)
        });
    }

    ngOnDestroy(): void {
        this.themeSub?.unsubscribe();
    }
}
